export enum REVIEW_APPROVAL_STATUS {
  NOT_READY_FOR_REVIEW = "Not Ready For Approval",
  READY_FOR_REVIEW = "Ready For Approval",
  NEEDS_UPDATING = "Needs Updating",
  APPROVED = "Approved",
}
